import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { OrderTextBox } from '../OrderTextBox'
import orderService from '../OrderService';

export class DealerInfo extends Component {
    static displayName = DealerInfo.name;
    constructor(props) {
        super(props);
        const { id, dealerName, deliverAccountCode, saleAccountCode, addressee, zipcode, phone, address } = props.model;
        this.state = { dealerId: id, dealerName: dealerName, deliverCodes: [], salesCodes: [], deliverAccountCode: deliverAccountCode, saleAccountCode: saleAccountCode, addressee: addressee, zipcode: zipcode, phone: phone, address: address, uploading: false };        
        this.handleInputChange = this.handleInputChange.bind(this);               
    }

    
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }
    
    componentDidMount() {       
        this._subscription = orderService.subscribe(() => this.orderCommitting());        
    }

    orderCommitting() {
        orderService.updateDealerInfo(this.state);
    }

    componentWillUnmount() {
        orderService.unsubscribe(this._subscription);
    }       
    
    render() {
        
        return (
            <div className="w-full font-bold">
                <div className="border-2 border-gray-300" >
                    <div className="flex flex-row border-b-2 border-gray-100 p-1">
                        <label className="place-self-center"><FormattedMessage id="DealerName" /></label>
                        <OrderTextBox classnames="col-span-5 bg-gray-100 flex-auto ml-1" name="dealerName" readOnly="readonly" value={this.state.dealerName} />
                    </div>
                    <div className="grid grid-cols-2">
                        <div className="flex flex-row justify-between p-1">
                            <label className="whitespace-nowrap place-self-center mr-1"><FormattedMessage id="SaleAccountCode" /><span className="font-bold text-red-600">*</span></label>
                            <OrderTextBox classnames="flex-grow w-full" Value={this.state.saleAccountCode} />
                        </div>
                        <div className="flex flex-row justify-between p-1">
                            <label className="whitespace-nowrap place-self-center mr-1"><FormattedMessage id="DeliverAccountCode" /><span className="font-bold text-red-600">*</span></label>
                            <OrderTextBox classnames="flex-grow w-full" value={this.state.deliverAccountCode} />
                        </div>                                               
                    </div>                    
                </div>
                <div className="border-2 border-gray-300 mt-1" >
                    <div className="grid grid-cols-2">
                        <div className="flex flex-row justify-between p-1">
                            <label className="whitespace-nowrap place-self-center mr-1"><FormattedMessage id="Addressee" /><span className="font-bold text-red-600">*</span></label>
                            <OrderTextBox classnames="flex-grow mx-1 w-full" name="addressee" value={this.state.addressee ?? ""} onChange={this.handleInputChange} />
                        </div>
                        <div className="flex flex-row justify-between p-1">
                            <label className="whitespace-nowrap place-self-center mr-1"><FormattedMessage id="Phone" /><span className="font-bold text-red-600">*</span></label>
                            <OrderTextBox classnames="flex-grow mx-0 w-full" name="phone" value={this.state.phone ?? ""} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <label className="pl-1"><FormattedMessage id="Address" /><span className="font-bold text-red-600">*</span></label>
                        <textarea className="text-xs py-1 leading-4 bg-gray-100 border-gray-200 focus:ring-indigo-500 focus:border-indigo-500 rounded-sm m-1 h-10" value={this.state.address??""} name="address" onChange={this.handleInputChange} />
                    </div>
                </div>
            </div>
           
    );
  }
}